import { styled, Tab } from "@mui/material"

export interface TabVariants {
	color?: "primary" | "secondary" | "error" | "info" | "success" | "warning"
	inactive?: "true" | "false"
}

export const StyledTab = styled(Tab)<TabVariants>(({ theme }) => ({
	variants: [
		{
			props: { color: "warning" },
			style: {
				color: theme.vars?.palette.warning.main,
				backgroundColor: `rgba(${theme.vars?.palette.warning.mainChannel} / 0.1)`,
			},
		},
		{
			props: { color: "primary" },
			style: {
				color: theme.vars?.palette.primary.main,
				backgroundColor: `rgba(${theme.vars?.palette.primary.mainChannel} / 0.1)`,
			},
		},
		{
			props: { color: "error" },
			style: {
				color: theme.vars?.palette.error.main,
				backgroundColor: `rgba(${theme.vars?.palette.error.mainChannel} / 0.1)`,
			},
		},
		{
			props: { color: "success" },
			style: {
				color: theme.vars?.palette.success.main,
				backgroundColor: `rgba(${theme.vars?.palette.success.mainChannel} / 0.1)`,
			},
		},
		{
			props: { color: "info" },
			style: {
				color: theme.vars?.palette.info.main,
				backgroundColor: `rgba(${theme.vars?.palette.info.mainChannel} / 0.1)`,
			},
		},
		{
			props: { color: "secondary" },
			style: {
				color: theme.vars?.palette.secondary.main,
				backgroundColor: `rgba(${theme.vars?.palette.secondary.mainChannel} / 0.1)`,
			},
		},
		{
			props: { inactive: "true" },
			style: {
				textDecoration: "line-through",
			},
		},
	],
}))
